import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppCheckBox from "@/features/line-sheet-sets/app-checkbox";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLoadingDim from "@/features/pathpick/components/ui/PathPickLoadingDim";

interface Props {
  // 미리 받은 전체 선택 대상 수 — ids_only 상한(1만 건)에서 멈춘다.
  count: number;
  // 결과가 상한을 넘어 잘렸는지 — 그러면 "전체"가 아니라 "최대 n개"로 안내한다.
  isTruncated: boolean;
  isChecked: boolean;
  isIndeterminate: boolean;
  // id 조회·선택 반영 중 — 체크박스 위에 스피너를 덮고 입력을 막는다.
  isBusy: boolean;
  onToggle: () => void;
}

// 검색 결과 전체 선택 체크박스 — 상품 찾기와 담은 상품(작업 전 탭)이 같이 쓴다.
// AppCheckBox 라벨은 색을 바꿀 수 없어 박스만 쓰고 라벨은 따로 그린다.
// 라벨을 눌러도 토글되도록 클릭은 바깥 Flex가 받는다(AppCheckBox에 onChange를 주면 두 번 토글된다).
function PathPickSelectAllResultsCheckBox({
  count,
  isTruncated,
  isChecked,
  isIndeterminate,
  isBusy,
  onToggle,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <PathPickLoadingDim isLoading={isBusy}>
      <Flex
        alignItems={"center"}
        gap={"8px"}
        cursor={isBusy ? "default" : "pointer"}
        onClick={() => !isBusy && onToggle()}
      >
        <AppCheckBox
          size={"small"}
          isChecked={isChecked}
          isIndeterminate={isIndeterminate}
          isDisabled={isBusy}
        />
        <Text fontSize={"16px"} color={"#1272EF"}>
          {t(
            isTruncated
              ? "path_pick:select_all_results.max"
              : "path_pick:select_all_results.all",
            { total: count.toLocaleString() }
          )}
        </Text>
      </Flex>
    </PathPickLoadingDim>
  );
}

export default PathPickSelectAllResultsCheckBox;
